// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dot-wrapper-T18l1t{width:100%;margin:8px 0 0}.dot-wrapper-no-avatar-gl8d3t{margin:8px 0 0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dot-wrapper": `dot-wrapper-T18l1t`,
	"dotWrapper": `dot-wrapper-T18l1t`,
	"dot-wrapper-no-avatar": `dot-wrapper-no-avatar-gl8d3t`,
	"dotWrapperNoAvatar": `dot-wrapper-no-avatar-gl8d3t`
};
export default ___CSS_LOADER_EXPORT___;
